export default "__VITE_PUBLIC_ASSET__8966adfb__"